module.exports = __webpack_public_path__ + "static/media/Illus-Dressing_1@3x.19f6742a.png";